export const dashConstants = {
  CHAT_REQUEST: 'CHAT_REQUEST',
  CHAT_SUCCESS: 'CHAT_SUCCESS',
  CHAT_FAILURE: 'CHAT_FAILURE',

  COTIZACION_REQUEST: 'COTIZACION_REQUEST',
  COTIZACION_SUCCESS: 'COTIZACION_SUCCESS',
  COTIZACION_FAILURE: 'COTIZACION_FAILURE'
};